const favFeedback = {
  init () {

  $('.simplefavorite-button').click(function() {
    if ($(this).text() == 'Favorite ') {
      $(this).addClass('favourites-feedback');
      console.log('Favourite added');
    }
    setTimeout(function() {
        $(this).removeClass('favourites-feedback');
        $(this).addClass('no-fav');
       }, 7000);
  });

  }
};

export default favFeedback;



// WEBPACK FOOTER //
// ./src/components/01-elements/favourites-feedback/favourites-feedback.js